export default __webpack_public_path__ + "static/media/Dad&Eric400.6f4542d4.jpg";